import { Component } from "@angular/core";

import { ActivatedRoute, Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { ToastrService } from "ngx-toastr";
import { UploadService } from "../upload/service/upload.service";
import { CategoryService } from "../category/services/category.service";
import { CamerallaAuthService } from "../../shared/services/authentication-services/cameralla-auth.service";
import { UserService } from "../user/services/user.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { CroppedPhotoClass } from "../../shared/classes/CroppedPhotoClass";
import { FormGroup } from "@angular/forms";
import { FormlyFieldConfig } from "@ngx-formly/core";
import * as _ from "underscore";
import { GroupService } from "../user/services/group.service";
import { EventService } from "../../shared/services/event.service";
import { UploadPhotoService } from "../../shared/services/upload-photo.service";

@Component({
  selector: "app-management",
  templateUrl: "./management.html",
})
export class ManagementComponent extends CroppedPhotoClass {
  localUserId;
  onlyKampsport;
  currentUsers = [];
  form = new FormGroup({});

  fields: FormlyFieldConfig[] = [
    {
      key: "customer",
      type: "autocomplete",
      templateOptions: {
        type: "text",
        placeholder: "Select user by name",
        required: false,
        change: (field, event) => {},
        autoOptions: {
          isMapIcon: false,
          displayField: "tittle",
          openMap: (event) => {
            if (event) {
            }
          },
          selectItem: (event, model) => {
            if (event.item && event.item.id) {
              this.userService
                .markModerator(event.item.id)
                .subscribe((res: any) => {
                  if (res.IsSuccess && res.Data.is_moderator === 1) {
                    this.currentUsers.push(res.Data);
                    this.toastr.success("Add moderator success", "SUCCESS");
                  } else {
                    this.toastr.error(res.Message);
                  }
                  this.form.get("customer").setValue(null);
                });
            }
          },
          remoteData: (term) => {
            return this.userService.searchCustomer(term, false);
          },
        },
      },
    },
  ];

  constructor(
    protected router: Router,
    protected http: HttpClient,
    protected toastr: ToastrService,
    protected uploadPhotoService: UploadPhotoService,
    protected categoryService: CategoryService,
    protected authService: CamerallaAuthService,
    protected userService: UserService,
    protected eventService: EventService,
    protected _modalService: NgbModal,
    protected groupService: GroupService,
    protected route: ActivatedRoute
  ) {
    super(toastr);
    this.localUserId = +this.authService.getLocalUserInfo()["id"];
    if (localStorage.getItem("onlyKampsport")) {
      this.onlyKampsport = localStorage.getItem("onlyKampsport");
    }

    if (!this.route.snapshot.paramMap.get("groupId")) {
      this.userService.searchCustomer("", true).subscribe((res) => {
        this.currentUsers = res;
      });
    }
  }

  onRemove(e) {
    if (e && e.id) {
      this.userService.markModerator(e.id).subscribe((res: any) => {
        if (res.IsSuccess && res.Data.is_moderator === 0) {
          this.currentUsers.push(res.Data);
          this.currentUsers = _.reject(this.currentUsers, function (d) {
            return d.id === e.id;
          });
          this.toastr.success("Remove moderator success", "SUCCESS");
        } else {
          this.toastr.error(res.Message);
        }
      });
    }
  }
}
